import React, { ReactNode } from "react";
import { ScrollViewNavigation, ScrollViewNavigationProps } from "../coobjects/ScrollViewNavigation";

export interface FooterPanelProps {
  children: ReactNode;
  isLocked?: boolean;
  scrollViewNavigationProps?: ScrollViewNavigationProps;
}

function FooterPanel(props: FooterPanelProps) {
  return (
    <div className="ms-Grid-row">
      <div
        className={"ms-Grid-col ms-sm12 ms-md12 ms-lg12"}
        style={{
          position: "fixed",
          zIndex: "99",
          bottom: 0,
          left: 0,
          backgroundColor: props.isLocked ? "var(--color-yellow" : "var(--color-lightblue)",
          padding: "15px 15px",
        }}
      >
        {props.children}
        {props.scrollViewNavigationProps && (
          <div
            style={{
              position: "absolute",
              width: "100%",
              height: "100%",
              top: 0,
              right: 0,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              pointerEvents: "none",
            }}
          >
            <ScrollViewNavigation {...props.scrollViewNavigationProps} />
          </div>
        )}
      </div>
    </div>
  );
}

export default FooterPanel;
